import { User } from '../shared/models';
import { PaperCoverComponent } from '../shared/ui';
import { AuthService, UserService, NativeChannelService, ConfigService } from '../shared/services';
import { Component, Input, Output, EventEmitter, OnInit, ViewChild } from '@angular/core';
import { MenuItem } from 'ng2-material-components/ng2-material-components';
import { Router } from '@angular/router';

@Component({
  selector: 'my-sidenav',
  styles: [require('./sidenav.component.scss')],
  template: require('./sidenav.component.pug'),
})
export class SideNavComponent implements OnInit {
  @ViewChild(PaperCoverComponent) paperCoverComponent;

  @Input() open: boolean;
  @Output() itemClicked = new EventEmitter<MenuItem>();

  menuItems: any;
  user = new User({});
  singoutDetails: boolean;

  constructor(private _authService: AuthService, private _userSvc: UserService,
              private _router: Router, private _nativeChannelService: NativeChannelService,
              private _config: ConfigService) {

    this.menuItems = [
      { id: '1', title: 'Dashboard', icon: 'view-dashboard', route: '/dashboard' },
      {
        id: '2', title: 'Employees', icon: 'accounts', children: [
          { id: '21', title: 'Scores', icon: 'star-outline', route: '/employees/scores' },
          { id: '22', title: 'Salaries', icon: 'money-box', route: '/employees/salaries' },
        ]
      },
      { id: '3', title: 'Locations', icon: 'navigation', route: '/locations' },
      { id: '4', title: 'Customers', icon: 'accounts-list-alt', route: '/customers' },
      { id: '5', title: 'Inventory', icon: 'assignment-check', route: '/inventory' , children: [
          { id: '51', title: 'Inventory', icon: 'assignment-check', route: '/inventory' },
          { id: '52', title: 'Transfer', icon: 'swap', route: '/inventory/transfer' },
          { id: '53', title: 'Transfer History', icon: 'calendar-alt', route: '/inventory/transfer-history' },
        ]
      },
       {id: '6', title: 'Accounting', icon: 'balance-wallet', children: [
         { id: '61', title: 'Profit/Loss', icon: 'eye', route: '/accounting/profit-loss' },
         { id: '62', title: 'Payment Methods', icon: 'card', route: '/accounting/payment' },
         { id: '63', title: 'Refunds', icon: 'refresh', route: '/accounting/refunds' },

        ]
      },
      { id: '7', title: 'Check In/Out', icon: 'alarm-check', route: '/clock-in-out' },
      { id: '8', title: 'Bill & Payments', icon: 'money-box' },
    ];
  }

  ngOnInit() {
    this._userSvc.user$.subscribe(user => {
      this.user = user ? user : new User(null);
    });
  }

  callSupport() {
    this._nativeChannelService.callPhoneNumber('18883706682');
  }

  navigate(route: string) {
    this._router.navigate([route]);
  }

  onMenuItemClicked(item: MenuItem) {
    if (item.id === String(8)) {
      if (!this._nativeChannelService.openLink(this._config.getContext('ba').url)) {
        window.open(this._config.getContext('ba').url);
      }
    }
  }

  /*singoutMode() {
    setTimeout(() => this.singoutDetails = true, 100);
  }

  singout() {
    this._authService.signout(true);
    this.singoutDetails = false;
  }

  /*coverClosed(e: MouseEvent) {
     e.preventDefault();
     this.paperCoverComponent.effect = 'slideOutLeft';
     setTimeout(() => this.singoutDetails = false, 1200);
  }*/

  switchAccount(e: MouseEvent) {
     e.preventDefault();
     this.singoutDetails = false;
     this._router.navigate(['accounts']);
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/sidenav/sidenav.component.ts